import PropTypes from 'prop-types'
import React from 'react'
import css from './SourcesPopover.module.css'
import { Button, SearchInput } from '@segment/react-ui-library'
import cn from 'classnames'
import Popover from 'ui/Popover'
import Link from 'ui/Link'

export default function SourcesPopover (props) {
  const {
    children,
    title,
    sources,
    workspaceSlug,
    integrationSlug,
    canAddSources,
    searchTerm,
    onSearchChange,
    onOpen,
    onAddSourceClick,
    onSourceClick
  } = props
  const isEmpty = sources.length === 0 && !searchTerm

  function addSourceClick () {
    onAddSourceClick(isEmpty)
  }

  const content = isEmpty ? (
    <div className={cn(css.main, css.empty)}>
      <svg width='78' height='48' viewBox='0 0 78 48'>
        <g fill='#49B882'>
          <path d='M48.427 15.47v27.92c0 1.51 1.22 2.728 2.727 2.728h14.133c1.504 0 2.727-1.222 2.727-2.73V15.47c0-1.51-1.22-2.73-2.727-2.73H51.154c-1.504 0-2.727 1.224-2.727 2.73zm-1.444 0c0-2.303 1.87-4.17 4.17-4.17h14.134c2.305 0 4.172 1.864 4.172 4.17v27.92c0 2.3-1.87 4.168-4.18 4.168H51.15c-2.305 0-4.17-1.865-4.17-4.17V15.47z' />
          <path d='M58.22 42.883c-1.35 0-2.445-1.092-2.445-2.438 0-1.347 1.095-2.44 2.446-2.44 1.36 0 2.45 1.093 2.45 2.44 0 1.346-1.09 2.438-2.44 2.438zm0-1.44c.554 0 1.002-.447 1.002-.998 0-.552-.448-1-1-1-.554 0-1.003.448-1.003 1 0 .55.44.998 1 .998zm-2.04-24.73h4.092c.4 0 .722-.322.722-.72 0-.397-.323-.72-.722-.72H56.18c-.4 0-.723.323-.723.72 0 .398.323.72.722.72zm-3.89 9.284h11.497c.4 0 .722-.323.722-.72 0-.398-.33-.72-.73-.72H52.29c-.4 0-.723.322-.723.72 0 .397.323.72.722.72zm0 4.397h3.58c.4 0 .723-.323.723-.72 0-.398-.323-.72-.722-.72h-3.58c-.4 0-.72.322-.72.72 0 .397.33.72.72.72zM19.567 9.926h13.29c.398 0 .722-.322.722-.72 0-.397-.33-.72-.73-.72H19.56c-.396 0-.72.323-.72.72 0 .398.324.72.72.72zm0 6.788h10.728c.4 0 .722-.323.722-.72 0-.398-.323-.72-.722-.72H19.567c-.398 0-.722.322-.722.72 0 .397.324.72.722.72z' />
          <path d='M13.674 33.83V5.99c0-2.38 1.936-4.31 4.324-4.31h41.82c2.39 0 4.325 1.93 4.325 4.31v1.68c0 .398.323.72.722.72.4 0 .722-.322.722-.72V5.99c0-3.175-2.582-5.75-5.768-5.75H17.99c-3.186 0-5.768 2.575-5.768 5.75v27.84c0 .398.322.72.72.72.4 0 .723-.322.723-.72zm29.92 5.28c.4 0 .722-.322.722-.72 0-.397-.324-.72-.723-.72H.963c-.4 0-.722.323-.722.72 0 1.335.54 2.614 1.48 3.557.95.944 2.23 1.474 3.57 1.474h38.34c.4 0 .725-.32.725-.72 0-.39-.324-.72-.723-.72H5.287c-.956 0-1.87-.37-2.547-1.05-.505-.5-.84-1.13-.984-1.82H43.59zm28.966 2.87h-.24c-.4 0-.724.323-.724.72 0 .398.324.72.723.72h.24c2.78 0 5.04-2.25 5.04-5.03 0-.397-.328-.72-.72-.72h-4.56c-.4 0-.73.323-.73.72 0 .398.323.72.722.72h3.765c-.334 1.638-1.787 2.87-3.53 2.87z' />
          <path d='M26.934 23.663v4.956c0 .05.03.08.07.08h12.773c.036 0 .07-.04.07-.09v-4.95c0-.055-.03-.086-.07-.086H27.004c-.035 0-.07.035-.07.085zm-1.444 0c0-.84.675-1.525 1.514-1.525h12.773c.84 0 1.515.68 1.515 1.525v4.956c0 .83-.675 1.52-1.515 1.52H27.004c-.84 0-1.514-.68-1.514-1.53v-4.95z' />
        </g>
      </svg>

      <p className={css.emptyText}>
        You need to have a Source such as a Website, Mobile App or Cloud App to
        connect this integration too.
      </p>

      <Button
        primary
        is='a'
        href={`/${workspaceSlug}/sources/catalog`}
        onClick={addSourceClick}>
        Add Source
      </Button>
    </div>
  ) : (
    <div className={css.main}>
      <div className={css.header}>
        <h2 className={css.title}>{title}</h2>
        {canAddSources &&
          <div className={css.addSource}>
            <Link
              href={`/${workspaceSlug}/sources/catalog`}
              rel='external'
              underline={false}
              onClick={addSourceClick}>
              Add Source
            </Link>
          </div>
        }
      </div>

      <div className={css.body}>
        {(sources.length > 5 || searchTerm) &&
          <SearchInput
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder='Type to search…'
            marginTop='8px' />
        }

        {sources.length > 0 ? (
          <ul className={css.sources}>
            {sources.map(source => {
              const name = source.name || source.slug
              return (
                <li key={source.slug} className={css.source}>
                  <a
                    href={`/${workspaceSlug}/sources/${source.slug}/integrations/${integrationSlug}`}
                    onClick={() => onSourceClick(source.slug)}
                    title={name}
                  >
                    {name}
                  </a>
                </li>
              )
            })}
          </ul>
        ) : (
          <div className={css.noMatch}>
            No {title} for ‘{searchTerm}’
          </div>
        )}

      </div>
    </div>
  )

  return (
    <Popover
      content={content}
      onOpen={onOpen}
      onClose={() => onSearchChange('')}>
      {children}
    </Popover>
  )
}

SourcesPopover.displayName = 'SourcesPopover'

SourcesPopover.defaultProps = {
  onAddSourceClick: () => {},
  onSourceClick: () => {}
}

SourcesPopover.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  sources: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired
  })).isRequired,
  workspaceSlug: PropTypes.string.isRequired,
  integrationSlug: PropTypes.string.isRequired,
  canAddSources: PropTypes.bool.isRequired,
  searchTerm: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  onOpen: PropTypes.func,
  onAddSourceClick: PropTypes.func,
  onSourceClick: PropTypes.func
}



// WEBPACK FOOTER //
// ./components/IntegrationsCatalog/SourcesPopover.js